export const STATUS = {
  IN_PROGRESS: 1,
  CREATED: 2,
};
